// extracted by mini-css-extract-plugin
export var arrows = "_63-5";
export var decrementer = "_63-9";
export var disabled = "_63-3";
export var error = "_63-1";
export var hiddenText = "_63-a";
export var incrementer = "_63-8";
export var input = "_63-7";
export var inputWrapper = "_63-0";
export var leadingIcon = "_63-b";
export var readonly = "_63-2";
export var regular = "_63-6";
export var small = "_63-4";